import { render, staticRenderFns } from "./modalFormularios.vue?vue&type=template&id=3f306cd5&"
import script from "./modalFormularios.vue?vue&type=script&lang=js&"
export * from "./modalFormularios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports